import axios from './axios';

const axiosSWRFetcher = url => axios.get(url).then(res => res.data);

export default axiosSWRFetcher;
